import React from "react";
import FormText from "./FormText";

const FormElementLabel: React.FC<{ label: string; required?: boolean }> = ({
  label,
  required = false,
}) => {
  return (
    <div className="text-sm mb-0.5 text-primaryHover opacity-80">
      <FormText bold text={`${label} ${required ? "*" : ""}`} />
    </div>
  );
};

export default FormElementLabel;
